import { render } from "./Alerts.vue?vue&type=template&id=869571b4"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"

import "./Alerts.vue?vue&type=style&index=0&id=869571b4&lang=css"

import exportComponent from "/home/milu/Projects/tesco-csapatnap/csapatnap.hu-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__